import { render, staticRenderFns } from "./repair-data-import.vue?vue&type=template&id=c8c1ddc6"
import script from "./repair-data-import.vue?vue&type=script&lang=ts"
export * from "./repair-data-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports